import React from "react";
import { BoxContainer } from "./styles";



function MasterUserBox({user}) {
	return (
		<>
			{user?.dados?.is_impersonated
				?
				<BoxContainer>
					<p>
						USUÁRIO MASTER:
						<b>{` ${user?.dados?.cargo !== '' ? user?.dados?.cargo : 'Revenda'}` || ''}</b>
					</p>
				</BoxContainer>
				:
				<></>
			}
		</>
	);
}

export default MasterUserBox;
